/**
 * API Error Provider and handler
 * 處理從 API 取得 status code >= 500 統一會執行的動作
 *
 */

import { createContext, useContext, useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';
import { popupToast } from '@Utils/toast';

const ErrorHandlerContext = createContext();

const SERVER_5OO_TOAST_ID = 'SEVER500';

export const ErrorHandler = ({ children }) => {
  const toast = useToast();
  const { t } = useTranslation();
  const [errorStatusCode, setErrorStatusCode] = useState(null);
  const [, setMsg] = useState('');
  const renderContent = useCallback(() => {
    if (errorStatusCode >= 500) {
      popupToast({
        toast,
        id: SERVER_5OO_TOAST_ID,
        noDuplicate: true,
        status: 'error',
        title: t('common.serverHaveSomeProblem'),
        duration: 7000,
      });
    }

    return children;
  }, [errorStatusCode]);

  const contextPayload = useMemo(() => {
    return { setErrorStatusCode, setMsg };
  }, [setErrorStatusCode, setMsg]);

  return (
    <ErrorHandlerContext.Provider value={contextPayload}>
      {renderContent()}
    </ErrorHandlerContext.Provider>
  );
};

export const useErrorHandlerContext = () => {
  const { setErrorStatusCode, setMsg } = useContext(ErrorHandlerContext);

  return { setErrorStatusCode, setMsg };
};
